import { angleUtil } from '../../lib/angleUtil-sidecar'
import { l } from '../../lib/imports'
import type { ISPD } from '../../sprites/sprites'
import { sprites } from '../../sprites/sprites-sidecar'
import { voyageColors } from './voyageColors-sidecar'

export enum EVoyageCarryableType {
  Default = -1,
  Null = 0,
  Coffee = 1,
  BattleRifle = 2,
  Mop = 3,
  Extinguisher = 4,
  Wrench = 5,
  Medpack = 6,
  Torpedo = 7,
  AlienCorpse = 8,
  CrewCorpse = 9,
  Firebomb = 10,
  Breachbomb = 11,
}

export interface IVoyageCarryableData {
  type: EVoyageCarryableType
  frame: ISPD
  frames: ISPD[]
  code: string
  name: string
  info: string
  rackOx: number
  rackOy: number
  carryScaleX: number
  carryOx: number
  carryOy: number
  scale: number
  tint: number
  rotation: number
}

const _default: IVoyageCarryableData = {
  code: 'default',
  name: 'Default',
  frame: sprites.voyTileCheckerFine1[0],
  frames: [],
  type: EVoyageCarryableType.Default,
  info: 'Default',
  rackOx: 0,
  rackOy: 0,
  carryScaleX: 1,
  carryOx: 8,
  carryOy: 0,
  scale: 2,
  tint: 0xffffff,
  rotation: 0,
}

let dataList: IVoyageCarryableData[] = []

export function register(data: Partial<IVoyageCarryableData>) {
  let d = Object.assign({}, _default, data)
  dataList.push(d)
  return d
}

export function find(type: EVoyageCarryableType) {
  return l.find(dataList, (c) => c.type === type)
}

export function tryFindByCode(code: string) {
  return l.find(dataList, (c) => code.startsWith(c.code)) || null
}

export function registerAll() {
  register({
    type: EVoyageCarryableType.Null,
    frame: sprites.voyTileCheckerFine2[0],
    name: 'Null',
    code: 'null',
  })
  register({
    type: EVoyageCarryableType.Coffee,
    // frame: sprites.voyItemCoffee[0],
    frame: sprites.voyInkItemCoffee[0],
    name: 'Coffee',
    code: 'coffee',
    info: 'Speeds you up!',
    scale: 0.3,
    carryScaleX: -1,
    carryOx: 8,
    carryOy: 2,
  })
  register({
    type: EVoyageCarryableType.BattleRifle,
    // frame: sprites.voyItemBattleRifle[0],
    frame: sprites.voyInkItemBattlerifle[0],
    name: 'Battle Rifle',
    code: 'br',
    info: 'Battle Rifles - for when you want aliens dead faster (TM)',
    scale: 0.3,
    rackOx: -6,
    rackOy: -2,
  })
  register({
    type: EVoyageCarryableType.Mop,
    // frame: sprites.voyItemMop[0],
    frame: sprites.voyInkItemMop[0],
    name: 'Mop',
    code: 'mop',
    info: 'Clean up splatters and spilled coffee',
    scale: 0.3,
    rackOy: -2,
    carryOx: 14,
  })
  register({
    type: EVoyageCarryableType.Wrench,
    // frame: sprites.voyItemWrench[0],
    frame: sprites.voyInkItemWrench2[0],
    name: 'Wrench',
    code: 'wr',
    info: 'Fix things faster',
    scale: 0.3,
  })
  register({
    type: EVoyageCarryableType.Medpack,
    //frame: sprites.voyItemMedpack[0],
    frame: sprites.voyInkItemMedpack[0],
    name: 'Medpack',
    code: 'med',
    info: 'Heal nearby crew',
    scale: 0.3,
    rackOx: 1,
    rackOy: -1,
  })
  register({
    type: EVoyageCarryableType.Extinguisher,
    // frame: sprites.voyItemExtinguisher[0],
    frame: sprites.voyInkItemExtinguisher[0],
    name: 'Fire Extinguisher',
    code: 'ext',
    info: 'Extinguishes fires',
    rackOx: -2,
    scale: 0.3,
    carryOx: 12,
  })
  register({
    type: EVoyageCarryableType.Torpedo,
    // frame: sprites.voyItemTorpedo[0],
    frame: sprites.voyInkItemTorpedo[0],
    name: 'Torpedo',
    code: 'torp',
    info: 'Load into torpedo tube. Smells like potatoes',
    scale: 0.3,
    rackOx: -4,
  })

  register({
    type: EVoyageCarryableType.AlienCorpse,
    // frame: sprites.voyTileCrew[0],
    frame: sprites.voyInkMonsterAlien[0],
    name: 'Alien coprse',
    code: 'corpse-a',
    info: 'A dead alien',
    rackOx: 0,
    carryOx: 6,
    scale: 0.25,
    rotation: angleUtil.turn * 0.25,
    tint: voyageColors.greenDull,
  })

  register({
    type: EVoyageCarryableType.CrewCorpse,
    frame: sprites.voyTileCrew[0],
    name: 'Crew coprse',
    code: 'corpse-c',
    info: 'A dead crewmember',
    rackOx: 0,
    carryOx: 6,
  })

  register({
    type: EVoyageCarryableType.Firebomb,
    // frame: sprites.voyItemBomb[0],
    frame: sprites.voyInkItemBomb1[0],
    frames: [sprites.voyInkItemBomb1[0], sprites.voyInkItemBomb2[0]],
    name: 'Firebomb',
    code: 'firebomb',
    info: 'A firebomb',
    rackOx: 0,
    carryOx: 6,
    scale: 0.3,
    tint: voyageColors.yellow,
  })

  register({
    type: EVoyageCarryableType.Breachbomb,
    frame: sprites.voyInkItemBomb2[0],
    frames: [sprites.voyInkItemBomb1[0], sprites.voyInkItemBomb2[0]],
    name: 'Breachbomb',
    code: 'breachbomb',
    info: 'A breachbomb',
    rackOx: 0,
    carryOx: 6,
    scale: 0.3,
    tint: voyageColors.red,
  })

  // register({
  //   type: EVoyageCarryableType.Suit,
  //   frame: sprites.voyItemExtinguisher[0],
  //   name: 'Suit',
  //   code: 'suit',
  // })
}
